<form [formGroup]="formGroup">
    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title white" id="exampleModalLabel">Editar contacto</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="save()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">
                    <h6 class="subtitulo-pack-form">Datos personales </h6>
                    <button *ngIf="userForm !== null" class="btn btn-sm btn-green" (click)="copyUserData()">Usar datos del cliente</button>
                    <div class="form-row">
                        <div class="col-lg-3 mt-1">
                            <mat-form-field>
                                <mat-label>Tipo documento</mat-label>
                                <select matNativeControl required formControlName="account_doctype"
                                        [value]="formGroup.get('account_doctype').value"
                                        (change)="changeTypeDocument($event); setMaxLengthByDoc($event.target.value)">
                                    <option *ngFor="let documentType of documentTypes" value="{{ documentType.digo_code }}">
                                        {{ documentType.digo_code }}
                                    </option>
                                    <option *ngIf="requestCompanyInfo">CIF</option>
                                </select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3 mt-1">
                            <mat-form-field>
                                <mat-label>Nº de documento</mat-label>
                                <input matInput="" 
                                    type="text" 
                                    oninvalid="" 
                                    formControlName="account_doc"
                                    [maxLength]="maxLengthByDoc"
                                    [value]="formGroup.get('account_doc').value">
                                <!-- error -->
                                <mat-error *ngIf="formGroup.get('account_doc')?.errors?.required">
                                    Campo obligatorio.
                                </mat-error>
                                <mat-error *ngIf="formGroup.get('account_doc')?.errors?.doc && !formGroup.get('account_doc')?.errors?.required">
                                    Número de documento erróneo
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3 mt-1">
                            <mat-form-field>
                                <mat-label>Nombre</mat-label>
                                <input matInput="" type="text" oninvalid=""
                                       formControlName="account_firstName"
                                       [value]="formGroup.get('account_firstName').value">
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3 mt-1">
                            <mat-form-field>
                                <mat-label>Apellido1</mat-label>
                                <input matInput="" type="text" oninvalid=""
                                       formControlName="account_surname1"
                                       [value]="formGroup.get('account_surname1').value">
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3 mt-1">
                            <mat-form-field>
                                <mat-label>Apellido2</mat-label>
                                <input matInput="" type="text" oninvalid=""
                                       formControlName="account_surname2"
                                       [value]="formGroup.get('account_surname2').value">
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 mt-1" *ngIf="requestCompanyInfo && requireCif">
                            <mat-form-field>
                                <mat-label>Razón social</mat-label>
                                <input matInput="" type="text" oninvalid="" formControlName="account_company"
                                       [value]="formGroup.get('account_company').value">
                            </mat-form-field>
                        </div>
                    </div>
                    <h6 class="subtitulo-pack-form">Datos bancarios</h6>
                    <div class="form-row">
                        <div class="col-lg-6 mt-1">
                            <mat-form-field>
                                <mat-label>IBAN* (ESXX XXXX XXXX XX XXXXXXXXXX)</mat-label>
                                <input matInput="" type="text" oninvalid="" formControlName="bank_account"
                                       [value]="formGroup.get('bank_account').value">
                            </mat-form-field>
                        </div>
                    </div>
                    <div align="center">
                        <br><br>
                        <a class="btn btn-green btn-sm mb-3" role="button" (click)="save()">Guardar</a>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="mt-3">
        <div class="form-row" [ngClass]="{'account' : migrationData && migrationData.migrationshowBanking, 'active' : migrationData && migrationData.migrationshowBanking && accountSelected === '0' }" (click)="selectTypeAccount('0')">
            <div class="col-lg-6" [ngClass]="{'ps-5' : migrationData && migrationData.migrationshowBanking }">
                <mat-form-field>
                    <mat-label>IBAN* (ESXX XXXX XXXX XX XXXXXXXXXX)</mat-label>
                    <input #bank_account id="bank_account" matInput type="text" required formControlName="bank_account" [ngModel]="model.bank_account"
                           mask="AA00 0000 0000 00 0000000000"
                           (input)="onIbanChange($event)">
                </mat-form-field>
            </div>

            <div class="col-lg-6 mb-0">
                <div class="jumbotron-form2">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <span class="label-ad-text2">Titular de la cuenta</span>
                            <br>
                            <span class="label-ad-text">{{ model.account_firstName + ' ' + model.account_surname1 + ' ' + model.account_surname2 }}</span>
                        </div>
                        <small class="text-muted btn-muted">
                            <button class="btn btn-green btn-sm" role="button" (click)="open(content)">Cambiar</button>
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row my-3 account" [ngClass]="{ 'active' : accountSelected === '1' }" *ngIf="migrationData && migrationData.migrationshowBanking" (click)="selectTypeAccount('1')">
            <div class="col-md-8 ps-5 align-self-center">
                <div class="col-12 text-muted ps-0">
                    Utilizar la cuenta bancaria asignada al cliente
                </div>
                <div class="label-ad-text2">
                    Por favor confirma con el cliente que si su entidad bancaria se ha fusionado con otra, se asegure que esta cuenta bancaria que quiere mantener esté actualizada posteriormente a haberse realizado dicha fusión.
                </div>
            </div>
        </div>
    </div>
</form>
